
<form #f="ngForm" (ngSubmit)="inviteUser()">
    <div class="p-grid">
        <div class="p-col-12 error-notify-text">
            <app-validateform [formToValidate]="inviteUserForm"></app-validateform>
        </div>
    </div>
    <div *ngIf="!inviteSuccess; else completed">
        <div class="p-grid">
            <div class="p-col-12 p-lg-2 p-md-2 p-sm-2">
                <button pButton type="submit" class="fullwidthbtn" label="Submit"></button>
            </div>
            <div class="p-col-12 p-lg-2 p-md-2 p-sm-2">
                <button pButton type="button" class="fullwidthbtn" label="Cancel" (click)="cancelInvite()"></button>
            </div>
        </div>
        <div>
            <p-accordion [multiple] ="true">
                <p-accordionTab header="USER INFORMATION" [selected]="true">
                    <div class="p-grid">
                        <div class="p-col-12 p-lg-6 p-md-6">
                            <span class="p-float-label">
                                <input type="text"
                                       pInputText
                                       [(ngModel)]="user.FName"
                                       name="FirstName"
                                       requiredNoSpaceValidator
                                       data-display-name="FirstName" />
                                <label for="float-input">First Name*</label>
                            </span>
                        </div>
                        <div class="p-col-12 p-lg-6 p-md-6">
                            <span class="p-float-label">
                                <input type="text"
                                       pInputText
                                       [(ngModel)]="user.LName"
                                       name="LastName"
                                       requiredNoSpaceValidator
                                       data-display-name="LastName" />
                                <label for="float-input">Last Name*</label>
                            </span>
                        </div>
                        <div class="p-col-12 p-lg-6 p-md-6">
                            <span class="p-float-label">
                                <input type="text"
                                       pInputText
                                       [(ngModel)]="user.Email"
                                       name="Email"
                                       requiredNoSpaceValidator
                                       data-display-name="Email" />
                                <label for="float-input">Email*</label>
                            </span>
                        </div>
                        <div class="p-col-12 p-lg-6 p-md-6">
                            <span class="p-float-label">
                                <input type="text"
                                       pInputText
                                       [(ngModel)]="user.Title"
                                       name="Title"
                                       requiredNoSpaceValidator
                                       data-display-name="Title" />
                                <label for="float-input">Title*</label>
                            </span>
                        </div>
                        <div class="p-col-12 p-lg-6 p-md-6">
                            <span class="p-float-label">
                                <input type="text"
                                       pInputText
                                       [(ngModel)]="user.DirectPhone"
                                       name="DirectPhone"
                                       requiredNoSpaceValidator
                                       data-display-name="Direct Phone" />
                                <!--<p-inputMask  [(ngModel)]="user.DirectPhone"
                                               name="DirectPhone"
                                               requiredNoSpaceValidator
                                               data-display-name="Direct Phone"
                                                mask="+9 (999) 999-9999">
                                </p-inputMask>-->
                                <label for="p-float-label">Direct Phone*</label>
                            </span>
                        </div>
                        <div class="p-col-12 p-lg-6 p-md-6">
                            <span class="p-float-label">
                                <input type="text"
                                       pInputText
                                       [(ngModel)]="user.DirectPhoneExtn"
                                       name="Extension" />                              
                                <label for="p-float-label">Extension</label>
                            </span>
                        </div>
                        <div class="p-col-12 p-lg-6 p-md-6">
                            <span class="p-float-label">
                                <input type="text"
                                       pInputText
                                       [(ngModel)]="user.CellPhone"
                                       name="CellPhone" />
                                <label for="p-float-label">Cell Phone</label>
                            </span>
                        </div>
                        <div class="p-col-12 p-lg-6 p-md-6">
                            <span class="p-float-label">
                                <input type="text"
                                       pInputText
                                       [(ngModel)]="user.Fax"
                                       name="Fax" />
                                <label for="p-float-label">Fax</label>
                            </span>
                        </div>
                        <div class="p-col-12 p-lg-12 p-md-12">
                            <span class="p-float-label">
                                <input type="text"
                                       pInputText
                                       [(ngModel)]="user.MyPropertyListingUrl"
                                       name="MyPropertyListings" />
                                <label for="p-float-label">My Property Listings URL</label>
                            </span>
                        </div>
                        <div class="p-col-12">
                            <p-message severity="info" text="Check whether the phone numbers are in correct format, which is +country code region code (if applicable) and phone number, for example: +1 XXX XXX XXXX. You must use this format for both domestic and international phone numbers. Your phone number will appear exactly as entered." styleClass="mr-2"></p-message>
                        </div>
                    </div>
                </p-accordionTab>
                <p-accordionTab header="OFFICES" [selected]="true">
                    <div class="p-grid">
                        <div class="p-col-12">
                            <span class="p-float-label">
                                <p-dropdown inputId="dropdown"
                                            [autoDisplayFirst]="false"
                                            [showClear]="true"
                                            [options]="parentOfficeOptions"
                                            [(ngModel)]="user.ParentOfficeId"
                                            name="ParentOfficeId"
                                            (onChange)="onParentOfficeChange()"
                                            scrollHeight="450px"
                                            required
                                            data-display-name="ParentOffice"
                                            [filter]="true" filterBy="label">
                                </p-dropdown>
                                <label for="dropdown">Parent Office*</label>
                            </span>
                        </div>
                    </div>
                    <div *ngFor="let office of childOffices" class="p-field-checkbox">
                        <div class="p-grid">
                            <div class="p-col-12" style="margin-left:10px;">
                                <p-checkbox (onChange)="onChildOfficesChange($event, office.Id)"
                                            name="groupChildOffices" value="office" [value]="office"
                                            [(ngModel)]="selectedChildOffices"
                                            [inputId]="office.Id"
                                            data-display-name="Child Office(s)"></p-checkbox>
                                <label> {{office.Name}}, {{office.City}} {{office.StatesCode}} {{office.CountryID == 221 ? '' : office.CountriesName}}</label>
                            </div>
                            <div class="p-col-12" *ngIf="showRoles(office.Id)" style="margin-left:40px; padding-right:2.5rem;">
                                <div *ngFor="let role of roleOptions" class="p-field-checkbox">
                                    <p-checkbox name="{{office.Id}}groupRoles" value="role" [value]="role" [(ngModel)]="office.selectedRoles" [inputId]="role.Id" data-display-name="Office Role"></p-checkbox>
                                    <label pTooltip="{{role.ToolTip}}">{{role.Name}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </p-accordionTab>
                <p-accordionTab header="SECURITY ROLES" [selected]="true">
                    <div *ngFor="let role of appRoleOptions" class="p-field-checkbox">
                        <p-checkbox name="{{role.Id}}groupAppRoles"
                                    value="role"
                                    [value]="role"
                                    [(ngModel)]="selectedAppRoles"
                                    [inputId]="role.Id"
                                    [disabled]="(role.Name === 'officemanager')&&(!enableOfficeManagerRole)"></p-checkbox>
                        <label>{{role.Description}}</label>
                    </div>
                </p-accordionTab>
            </p-accordion>
        </div>
    </div>
</form>

<ng-template #completed>   
    Your invitation was successfully sent.  
</ng-template>
